// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3mQEe","gfeWrapper":"CalendarEvent_gfeWrapper__3bCbW"};